import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import glamorous from 'glamorous';
import Link from 'redux-first-router-link';

import Logo from '../assets/Logo';

import { actions as actionsAnalytics } from '../actions/analytics';
import { actions } from '../actions/app';
import { actions as actionsTara } from '../actions/tara';

import Footer from '../components/layout/Footer';
import HomeHeader from '../components/layout/HomeHeader';
import Main from '../components/layout/Main';
import Nav, {
  HomeNav,
  MenuIconButton,
  NavLeft,
  NavRight,
} from '../components/layout/Nav';

import HeaderContainer from '../containers/HeaderContainer';
import FooterContainer from '../containers/FooterContainer';
import NavContainer from '../containers/NavContainer';
import SearchTextFieldContainer from '../containers/SearchTextFieldContainer';


import { getSessionId } from '../reducers/app/sessionId';

import {
  getLocation,
  getLocationQuery,
} from '../reducers/location';

import RoutesOpen from '../routes/RoutesOpen';
import * as routeTypes from '../routes/types';

const Div = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
});

const styleHomeHeaderLogo = {
  height: 'auto',
  width: 300,
  maxWidth: '100%',
  marginTop: 104,
  marginBottom: 64,
};

class AppView extends React.PureComponent {
  constructor(props) {
    super(props);

    if (props.cookieSessionId) {
      props.appSetSessionId(props.cookieSessionId);
    } else {
      props.analyticsNewSessionRequest();
    }

    if (props.cookieUserId) {
      props.appSetUserId(props.cookieUserId);
    }

    if (props.surveyCompleted) {
      props.taraSetSurveyCompleted(true);
    }
  }

  state = {
    isViewingMobileMenu: false,
    isReady: !!this.props.sessionId,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.type !== this.props.location.type) {
      this.setIsViewingMobileMenu(false);
      document.documentElement.scrollTop = 0;
    }

    if (nextProps.sessionId && !this.state.isReady) {
      this.setIsReady(true);
    }
  }

  setIsViewingMobileMenu = isViewingMobileMenu => this.setState({ isViewingMobileMenu });
  setIsReady = isReady => this.setState({ isReady });

  handleClickMobileMenu = () => {
    this.setIsViewingMobileMenu(!this.state.isViewingMobileMenu);
  };

  renderNav() {
    const { type } = this.props.location;

    if (type === routeTypes.ROUTE_HOME) {
      return (
        <HomeNav>
          <NavContainer isHome />
        </HomeNav>
      );
    }

    const { curated, tara } = this.props.locationQuery;
    let to = { type: routeTypes.ROUTE_HOME };

    if (curated || tara) {
      to = {
        ...to,
        query: {
          curated,
          tara,
        },
      };
    }

    return (
      <Nav isViewingEvent={type === routeTypes.ROUTE_EVENTS_SHOW}>
        <NavLeft>
          <MenuIconButton
            onClick={this.handleClickMobileMenu}
            isViewingMobileMenu={this.state.isViewingMobileMenu}
          />
          <Link style={{ display: 'inline-flex' }} to={to}>
            <Logo white />
          </Link>
        </NavLeft>

        <NavRight>
          <NavContainer
            isViewingMobileMenu={this.state.isViewingMobileMenu}
          />
          <SearchTextFieldContainer />
        </NavRight>
      </Nav>
    );
  }

  renderHeader() {
    const { type } = this.props.location;

    if (type === routeTypes.ROUTE_HOME) {
      return (
        <HomeHeader>
          <Logo white style={styleHomeHeaderLogo} />
          <HeaderContainer />
        </HomeHeader>
      );
    }

    return null;
  }

  renderMain() {
    return (
      <Main>
        <RoutesOpen {...this.props} />
      </Main>
    );
  }

  renderFooter() {
    return (
      <Footer isViewingEvent={this.props.location.type === routeTypes.ROUTE_EVENTS_SHOW}>
        <FooterContainer />
      </Footer>
    );
  }

  render() {
    return (
      <Div id="AppView">
        {this.renderNav()}
        {this.renderHeader()}
        {this.state.isReady && this.renderMain()}
        {this.renderFooter()}
      </Div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  location: getLocation(state),
  locationQuery: getLocationQuery(state),
  sessionId: getSessionId(state),

  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  appSetSessionId: actions.appSetSessionId,
  appSetUserId: actions.appSetUserId,
  analyticsNewSessionRequest: actionsAnalytics.analyticsNewSessionRequest,
  taraSetSurveyCompleted: actionsTara.taraSetSurveyCompleted,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AppView);



// WEBPACK FOOTER //
// ./src/views/AppView.js